import { useCallback } from 'react'

import { useAppDispatch, useAppSelector } from 'shared/config/store'

import {
  selectSelectedSort,
  selectSortOrder,
  selectSortingOptions
} from '../model/selectors/appSelectors'
import {
  actions,
  SORT_ORDER
} from '../model/slice/appSlice'
import { type SortValue } from '../ui/dashboard/SortingControl'

export const useSorting = () => {
  const dispatch = useAppDispatch()

  const sortingOptions = useAppSelector(selectSortingOptions)
  const selectedSort = useAppSelector(selectSelectedSort)
  const selectedSortDirection = useAppSelector(selectSortOrder)

  const handleSortChange = useCallback((value: SortValue) => {
    dispatch(actions.setSelectedSort(value.key))
    dispatch(actions.setSortOrder(
      value.direction === 'asc' ? SORT_ORDER.ASC : SORT_ORDER.DESC
    ))
  }, [dispatch])

  const resetSorting = useCallback(() => {
    dispatch(actions.resetSortingSettings())
  }, [dispatch])

  const currentSortValue: SortValue = {
    key: selectedSort,
    direction: selectedSortDirection
  }

  return {
    sortingOptions,
    selectedSort,
    selectedSortDirection,
    currentSortValue,
    handleSortChange,
    resetSorting
  }
}
